
import ArticleInfoBaseTemplate from '../info/ArticleInfoBaseTemplate';
import ArticleInfoCover from '@root/modules/article/components/info/ArticleInfoCover.vue';
import ArticleAuthorList from '@root/modules/article/components/authors/ArticleAuthorList.vue';
import ArticleInfoSources from '@root/modules/article/components/info/ArticleInfoSources.vue';
import ArticleInfoTags from '@root/modules/article/components/info/ArticleInfoTags.vue';
import getStreamElement from '@root/modules/article/utils/getStreamElement';
import { faEye } from '@delfi.lt/fa-kit/icons/modules/classic/light';

export default ArticleInfoBaseTemplate.extend({
  components: {
    ArticleInfoCover,
    ArticleAuthorList,
    ArticleInfoSources,
    ArticleInfoTags,
  },
  data() {
    return {
      faEye,
    };
  },
  computed: {
    locale() {
      const { locale } = this.$channelConfig('settings');

      return locale.split('_')[0];
    },
    title() {
      return this.$props.article.content.title.html.replace(/(<\/?h1>)/gi, '');
    },
    showViews() {
      return this.$channelConfig('settings').showViews ?? false;
    },
    streamElement() {
      return getStreamElement(this.article);
    },
  },
});
